import { Outlet } from 'react-router-dom';

const OrdersPage = () => {
  return <Outlet />;
};

export default OrdersPage;
